import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Beslut } from '../../interfaces/beslut.interface';
import { ArbetstagareService } from './arbetstagare.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../session/session.service';
import { YesNoModalService } from '../../modal/yes-no.modal.service';
import { TranslateService } from '@ngx-translate/core';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { Arende } from '../../interfaces/arende.interface';

@Component({
  selector: 'app-arbetstagare',
  templateUrl: './arbetstagare.component.html',
  styleUrls: ['./arbetstagare.component.scss'],
  animations: [fadeInAnimation]
})
export class ArbetstagareComponent implements OnInit {
  constructor(
    protected service: ArbetstagareService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected yesNoModal: YesNoModalService,
    protected translate: TranslateService) { }

  public ngOnInit(): void {
    this.loadBeslut();
  }

  public beslut: Beslut[];

  private loadBeslut(): void {
    const doLoad = () => {
      setTimeout(() => {
        if (!this.beslut) {
          this.spinner.show();
        }
      }, 500);

      this.service.getBeslut(this.sessionService.activeInstance.id).subscribe(
        (result: Beslut[]) => {
          this.spinner.hide();
          this.beslut = result;
        },
        (error) => {
          this.spinner.hide();
        });
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(doLoad);
      return;
    }

    doLoad();
  }

  public reloadBeslut(): void {
    this.spinner.show();
    this.loadBeslut();
  }

  public getSum(items: object[], property: string): number {
    let sum = 0;
    for (let i = 0; i < items.length; i++) {
      sum += +items[i][property];
    }

    return sum;
  }

  public hasForsakransKrav(beslut: Beslut[]): boolean {
    return beslut.filter(b => b.harForsakransKrav).length > 0;
  }

  public disableForsakransLink(dateLast: string): boolean {
    return !dateLast || new Date(dateLast).getFullYear() === 1;
  }

  public get instanceName(): string {
    return this.sessionService.activeInstance.name;
  }

  public async openBesvaraForsakranModal(arende: Arende) {
    const handlingAgency = arende.handlaggsAvSkatteverket ? 'skv' : 'lst';
    const titleKey = `texts.forsakran-${handlingAgency}-modal-title`;
    const messageKey = `texts.forsakran-${handlingAgency}-modal-message`;
    const translations = await this.translate.get([titleKey, messageKey]).toPromise<{ [key: string]: string }[]>();
    this.yesNoModal.open(translations[titleKey], translations[messageKey], {
      buttonCallback: () => window.open(arende.besvaraForsakranUrl),
      options: { centered: true, size: 'lg' }
    });
  }
}
